<template>
    <div class="pdf-preview">
        <nav>
            <b-button variant="outline-primary" size="sm" :disabled="busy || page <= 1" @click="render(page - 1)" :aria-label="$t('AttachmentPreviousPage')"><feather-icon icon="ChevronLeftIcon" /></b-button>
            <span>{{ page }} / {{ pages }}</span>
            <b-button variant="outline-primary" size="sm" :disabled="busy || page >= pages" @click="render(page + 1)" :aria-label="$t('AttachmentNextPage')"><feather-icon icon="ChevronRightIcon" /></b-button>
        </nav>
        <p v-if="busy" role="status">{{ $t("Loading") }}...</p>
        <canvas ref="canvas" />
    </div>
</template>

<script>
import { BButton } from "bootstrap-vue";
export default {
    components: { BButton },
    props: { url: { type: String, required: true } },
    data: () => ({ page: 1, pages: 0, busy: true }),
    async mounted() {
        try {
            const base = `${process.env.BASE_URL}pdfjs/`;
            const pdfjs = await import(/* webpackIgnore: true */ `${base}pdf.js`);
            if (this._isBeingDestroyed || this._isDestroyed) return;
            pdfjs.GlobalWorkerOptions.workerSrc = `${base}pdf.worker.js`;
            this.loadingTask = pdfjs.getDocument({ url: this.url, isEvalSupported: false,
                standardFontDataUrl: `${base}standard_fonts/`, cMapUrl: `${base}cmaps/`, cMapPacked: true, wasmUrl: `${base}wasm/` });
            this.document = await this.loadingTask.promise;
            this.pages = this.document.numPages;
            await this.render(1);
        } catch (error) { if (!this._isBeingDestroyed && !this._isDestroyed) this.$emit("error"); }
    },
    beforeDestroy() {
        if (this.renderTask) this.renderTask.cancel();
        if (this.loadingTask) this.loadingTask.destroy();
    },
    methods: {
        async render(page) {
            this.busy = true;
            try {
                const documentPage = await this.document.getPage(page);
                if (this._isBeingDestroyed || this._isDestroyed) return;
                const viewport = documentPage.getViewport({ scale: 1.5 });
                const canvas = this.$refs.canvas;
                canvas.width = viewport.width;
                canvas.height = viewport.height;
                this.renderTask = documentPage.render({ canvasContext: canvas.getContext("2d"), viewport });
                await this.renderTask.promise;
                this.page = page;
            } catch (error) { if (!this._isBeingDestroyed && !this._isDestroyed) this.$emit("error"); }
            finally { this.busy = false; }
        }
    }
};
</script>

<style scoped>
.pdf-preview { max-height: 65vh; overflow: auto; background: #eee; padding: 12px; }
nav { display: flex; align-items: center; justify-content: center; gap: 16px; margin-bottom: 12px; }
canvas { display: block; max-width: 100%; height: auto; margin: auto; }
</style>
